import { render, staticRenderFns } from "./CATEGORY_NAME.vue?vue&type=template&id=e85f9e44"
import script from "./CATEGORY_NAME.vue?vue&type=script&lang=js"
export * from "./CATEGORY_NAME.vue?vue&type=script&lang=js"
import style0 from "./CATEGORY_NAME.vue?vue&type=style&index=0&id=e85f9e44&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports